import sameResource from "../../../AuthLogic/rules/sameResource";
import * as generateColor from "./generate-event-color";
import moment from "moment";

const generateCalendarEvents = async (
  { resourceDayTypesByYear, dayTypeRequestsByYear },
  loginId,
  selectedDayTypeResourceId,
  dayTypes,
  sameResource,
  showUnapprovedDays,
  dayTypesAll
) => {

  const { resourceDayTypes } = resourceDayTypesByYear;
  const { dayTypeRequests } = dayTypeRequestsByYear;
  
  selectedDayTypeResourceId = selectedDayTypeResourceId === "" ? loginId : selectedDayTypeResourceId
  let resourceDayTypeEvents = [];
  let dayTypeRequestEvents = [];
  let combinedFilteredEvents = [];
  
  let dayFound = false;
  //Build Day Type events
  if (resourceDayTypes) {
    for (let day of resourceDayTypes) {
      
      // check for approval status on upcoming and previously approved VAC days
      let startDay = day.date.slice(0, 10) || null;
      let colorText = generateColor.generateResourceDayType(day.myComment,day.comment);
      let tmpDayTypeName = day.dayTypeName;
      let comment = null;

      if(day.comment) {
        comment= "Comment: "+ day.comment;
      }
      if(day.myComment) {
        if (comment) 
          comment+= "\n";
        else
          comment = "";
        comment+= "My Comment: "+day.myComment;
      }

      let shortStatus = null

      if(dayTypeRequests) {
        var requestsForDay = dayTypeRequests.filter(function(d){
          return (d.fromDate.slice(0,10) == startDay || d.toDate.slice(0,10) == startDay) && day.tourId >0 && d.status== "Unapproved" 
        });
        
        if(requestsForDay.length>0) {
          colorText='red';
          tmpDayTypeName = "Requested: "+ requestsForDay[0].dayTypeName;
          shortStatus = 'U'
        }
      }

      let busy = displayBusy(sameResource,showUnapprovedDays,shortStatus,dayTypes,dayTypesAll,day);
      let title = busy ? "BUSY" :  day.dayTypeCode;
      let dtName = busy ? "BUSY" : (tmpDayTypeName || null);
      
      resourceDayTypeEvents.push({
        // each event represents an entire day on calendar
        resourceDayTypeId: day.resourceDayTypeId,
        dayTypeRequestId: day.dayTypeRequestId || null,
        title: title,
        start: startDay,
        color: "rgba(255, 0, 0, 0)", // transparent
        textColor: colorText, // TODO: replace genrate event color function
        sickPay: day.sickPay || null,
        allowTourScheduling: day.allowTourScheduling || null,
        restricted: null, //security <-- fix after filtering
        comment: comment,
        dayTypeName: dtName
      });
    }
  }

  resourceDayTypeEvents = filterResourceDayTypes(resourceDayTypeEvents);

  //Build Day Type Request events
  if (dayTypeRequests) {
    
    for (let dayRequest of dayTypeRequests) {
      let startDay = dayRequest.fromDate.slice(0, 10);
      let endDay = dayRequest.toDate.slice(0, 10);
      let tmpDayTypeName = dayRequest.dayTypeName;
      let comment = null;

      if(dayRequest.myComment) {
        comment= "My Comment: "+ dayRequest.myComment;
      }
      if(dayRequest.statusComment) {
        if (comment) 
          comment+= "\n";
        else
          comment = "";
        comment+= "Status Comment: "+ dayRequest.statusComment;
      }

      let shortStatus = dayRequest.shortStatus;
      let busy = displayBusy(sameResource,showUnapprovedDays,shortStatus,dayTypes,dayTypesAll, dayRequest);
      let title = busy ? "BUSY" : dayRequest.dayTypeCode;
      let dtName = busy ? "BUSY" :(tmpDayTypeName || null);


      if (startDay === endDay) {
        
        
        //check if request is only one day long
        dayTypeRequestEvents.push({
          //each event represents an entire day on calendar
          dayTypeRequestId: dayRequest.dayTypeRequestId,
          title: title,
          start: dayRequest.fromDate.slice(0, 10),
          color: "rgba(255, 0, 0, 0)", // transparent
          textColor: generateColor.generateDayTypeRequestTextColor(
            dayRequest.statusComment, dayRequest.myComment
          ),
          approvalStatus: dayRequest.status,
          isMultipleRequest: false, // needed for rendering a request spanning multiplpe days
          comment: comment,
          dayTypeName: dtName
        });
      } else {
        //check to see how many days we need to make duplicate events for
        let startDayMoment = moment(startDay);
        let endDayMoment = moment(endDay);
        let dayDifference = endDayMoment.diff(startDayMoment, "days"); //determines how many additional days events are needed for

        //title = busy ? "Busy" : (dayRequest.status=="Unapproved" ? dayRequest.dayTypeCode:dayRequest.dayTypeName);
        

        dayTypeRequestEvents.push({
          dayTypeRequestId: dayRequest.dayTypeRequestId,
          title: title,
          start: startDay,
          color: "rgba(255, 0, 0, 0)", // transparent
          textColor: generateColor.generateDayTypeRequestTextColor(
            dayRequest.statusComment, dayRequest.myComment
          ),
          approvalStatus: dayRequest.status,
          isMultipleRequest: true, // needed for rendering a request spanning multiplpe days
          comment: comment,
          dayTypeName: dtName
        });

        for (let i = 0; i < dayDifference; i++) {
          let newDay = startDayMoment.add(1, "day").format("YYYY-MM-DD");

          dayTypeRequestEvents.push({
            dayTypeRequestId: dayRequest.dayTypeRequestId,
            title: title,
            start: newDay,
            color: "rgba(255, 0, 0, 0)", // transparent
            textColor: generateColor.generateDayTypeRequestTextColor(
              dayRequest.statusComment, dayRequest.myComment
            ),
            approvalStatus: dayRequest.status,
            isMultipleRequest: true, // needed for rendering a request spanning multiplpe days broken up by a day type
            comment: comment,
            dayTypeName: dtName
          });
        }
      }
    }
  }

  dayTypeRequestEvents = filterDayTypeRequests(dayTypeRequestEvents);

  combinedFilteredEvents = filterCombinedArray(
    resourceDayTypeEvents,
    dayTypeRequestEvents
  );

  return generateBackgroundEvents(combinedFilteredEvents);
};

const filterResourceDayTypes = (events) => {
  let dayTypeIdsToRemove = [];

  // go through the events and delete duplicates, priority goes to approved day types and requests
  for (let i = 0; i < events.length; i++) {
    for (let k = i + 1; k < events.length; k++) {
      if (events[i].start === events[k].start) {
        let eventOne = events[i];
        let eventTwo = events[k];
        if (eventOne.resourceDayTypeId && eventTwo.resourceDayTypeId) {
          // if both events are day types
          dayTypeIdsToRemove.push(eventTwo.dayTypeRequestId);
        }
      }
    }
  }

  dayTypeIdsToRemove = [...new Set(dayTypeIdsToRemove)]; // removes duplicate ids

  events = events.filter((event) => {
    return !dayTypeIdsToRemove.includes(event.dayTypeRequestId);
  });

  return events;
};

const filterDayTypeRequests = (events) => {
  let dayTypeIdsToRemove = [];

  // go through the events and delete duplicates, priority goes to approved day types and requests
  for (let i = 0; i < events.length; i++) {
    for (let k = i + 1; k < events.length; k++) {
      if (events[i].start === events[k].start) {
        let eventOne = events[i];
        let eventTwo = events[k];

        if (
          eventOne.approvalStatus === "Unapproved" &&
          eventTwo.approvalStatus === "Unapproved"
        ) {
          // if both are unapproved
          if (eventTwo.isMultipleRequest) {
            // if its a part of a multi-day request we need to add the date to the object
            dayTypeIdsToRemove.push({
              id: eventTwo.dayTypeRequestId,
              date: eventTwo.start,
            });
          } else {
            dayTypeIdsToRemove.push({ id: eventTwo.dayTypeRequestId });
          }
        } else if (
          eventOne.approvalStatus === "Approved" &&
          eventTwo.approvalStatus === "Unapproved"
        ) {
          // if event 1 is approved
          if (eventTwo.isMultipleRequest) {
            dayTypeIdsToRemove.push({
              id: eventTwo.dayTypeRequestId,
              date: eventTwo.start,
            });
          } else {
            dayTypeIdsToRemove.push({ id: eventTwo.dayTypeRequestId });
          }
        } else {
          if (eventOne.isMultipleRequest) {
            dayTypeIdsToRemove.push({
              id: eventOne.dayTypeRequestId,
              date: eventOne.start,
            });
          } else {
            dayTypeIdsToRemove.push({ id: eventOne.dayTypeRequestId });
          }
        }
      }
    }

    if (events[i].approvalStatus === "Denied") {
      //remove if denied
      dayTypeIdsToRemove.push({ id: events[i].dayTypeRequestId });
    }
  }

  dayTypeIdsToRemove = [...new Set(dayTypeIdsToRemove)]; // removes duplicate ids

  let uniqueDayTypeIdsToRemove = Array.from(new Set(dayTypeIdsToRemove)).map(
    (dayType) => {
      if (dayType.date) {
        return dayTypeIdsToRemove.find(
          (a) => a.id === dayType.id && a.date === dayType.date
        );
      }
      return dayTypeIdsToRemove.find((a) => a.id === dayType.id);
    }
  );

  events = events.filter((event) => {
    let eventId = event.dayTypeRequestId;
    for (let dayTypeObject of uniqueDayTypeIdsToRemove) {
      if (eventId === dayTypeObject.id && !dayTypeObject.date) {
        return false;
      } else if (
        eventId === dayTypeObject.id &&
        dayTypeObject.date &&
        event.start === dayTypeObject.date
      ) {
        return false;
      }
    }
    return true;
  });

  return events;
};

// this function should resolve issues with RDTs and DTRs being on the same day
const filterCombinedArray = (resourceDayTypeEvents, dayTypeRequestEvents) => {
  let combinedArray = [...resourceDayTypeEvents, ...dayTypeRequestEvents];
  let dayTypeIdsToRemove = [];

  // go through the events and delete duplicates, priority goes to approved day types and requests
  for (let i = 0; i < combinedArray.length; i++) {
    for (let k = i + 1; k < combinedArray.length; k++) {
      if (combinedArray[i].start === combinedArray[k].start) {
        let eventOne = combinedArray[i];
        let eventTwo = combinedArray[k];

        if (eventOne.resourceDayTypeId && eventTwo.resourceDayTypeId) {
          // if both are RDTs
          dayTypeIdsToRemove.push({ id: eventTwo.dayTypeRequestId });
        } else if (eventOne.resourceDayTypeId && !eventTwo.resourceDayTypeId) {
          // if eventOne is a RDT
          if (eventTwo.isMultipleRequest) {
            dayTypeIdsToRemove.push({
              id: eventTwo.dayTypeRequestId,
              date: eventTwo.start,
            });
          } else {
            dayTypeIdsToRemove.push({ id: eventTwo.dayTypeRequestId });
          }
        } else if (!eventOne.resourceDayTypeId && eventTwo.resourceDayTypeId) {
          // if eventTwo is a RDT
          if (eventOne.isMultipleRequest) {
            dayTypeIdsToRemove.push({
              id: eventOne.dayTypeRequestId,
              date: eventOne.start,
            });
          } else {
            dayTypeIdsToRemove.push({ id: eventOne.dayTypeRequestId });
          }
        }
      }
    }
  }

  dayTypeIdsToRemove = [...new Set(dayTypeIdsToRemove)]; // removes duplicate ids

  //needs to factor in date as well
  let uniqueDayTypeIdsToRemove = Array.from(new Set(dayTypeIdsToRemove)).map(
    (dayType) => {
      if (dayType.date) {
        return dayTypeIdsToRemove.find(
          (a) => a.id === dayType.id && a.date === dayType.date
        );
      }
      return dayTypeIdsToRemove.find((a) => a.id === dayType.id);
    }
  );

  combinedArray = combinedArray.filter((event) => {
    let eventId = event.ResourceDayTypeId
      ? event.ResourceDayTypeId
      : event.dayTypeRequestId
      ? event.dayTypeRequestId
      : null;
    for (let dayTypeObject of uniqueDayTypeIdsToRemove) {
      if (eventId === dayTypeObject.id && !dayTypeObject.date) {
        return false;
      } else if (
        eventId === dayTypeObject.id &&
        dayTypeObject.date &&
        event.start === dayTypeObject.date
      ) {
        return false;
      }
    }
    return true;
  });

  return combinedArray;
};

const generateBackgroundEvents = (events) => {
  //add additional background events so we can change the colors
  let backgroundEvents = [];
  for (let event of events) {
    if (event.resourceDayTypeId) {
      backgroundEvents.push({
        start: event.start,
        approvalStatus: event.approvalStatus,
        resourceDayTypeId: event.resourceDayTypeId,
        color: generateColor.generateDayTypeColor(event), // TODO: color for day tyoe background
        rendering: "background",
      });
    } else {
      backgroundEvents.push({
        start: event.start,
        approvalStatus: event.approvalStatus,
        dayTypeRequestId: event.dayTypeRequestId,
        color: generateColor.generateDayTypeRequestColor(event.approvalStatus),
        rendering: "background",
      });
    }
  }

  let eventsAndBackgrounds = [...events, ...backgroundEvents];
  return eventsAndBackgrounds;
};

const displayBusy = (sameResource, showUnapproved, shortStatus, dayTypes,dayTypesAll, day) => {
  if (sameResource) return false;
  if (showUnapproved &&  (shortStatus == 'U' || shortStatus == 'H' ) ) return false;

  let dayOnAll = dayTypesAll.find((e)=>e.dayTypeId == day.dayTypeId);
  let allowByAll = dayOnAll == undefined || dayOnAll.overrideDayType == 0;
  
  let dayFound = dayTypes.find((e)=>(e.dayTypeId == day.dayTypeId) && e.showInCalendar && shortStatus !='U' && shortStatus !='H' )
  
  return (dayFound == undefined) && (!allowByAll || dayOnAll == undefined);
};


export default generateCalendarEvents;



// WEBPACK FOOTER //
// ./src/Components/DayType/utils/generate-events.js